import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { getEventDetailsById } from "../store/event.actions";
import { Store } from "@ngrx/store";
import { environment } from "src/environments/environment";
import { SubmitRsvp } from "../store/event.actions";
import { skip, take } from "rxjs/operators";
import { MatDialog } from "@angular/material";
import { NotificationThanksComponent } from "src/app/login/notification-thanks/notification-thanks.component";


@Component({
  selector: "app-event-form-submission",
  templateUrl: "./event-form-submission.component.html",
  styleUrls: ["./event-form-submission.component.scss"],
})
export class EventFormSubmissionComponent implements OnInit {
  eventRegForm: FormGroup;
  stopper$: Subject<any> = new Subject();
  isShowForm: boolean = false;
  EventById: any;
  eventId: any;
  userProfileImage: any;
  data: any;
  inviteeId:any;
  getData:any;
  formTemplate:any=[]
  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private store: Store<any>,
    private router:Router,
    private dialog: MatDialog,
  ) {
    this.activatedRoute.params
      .pipe(takeUntil(this.stopper$))
      .subscribe((params) => {
        console.log(params);
        if (params.id) {
          this.eventId = params.id;
          // this.inviteeId = params.invti_id;
        }
      });
      this.activatedRoute.queryParams
      .pipe(takeUntil(this.stopper$))
      .subscribe((params) => {
        console.log(params);
        // if (params['invitee_id']) {
          this.inviteeId = params['invitee_id'];
        // }
      });
    this.store.dispatch(new getEventDetailsById(this.eventId));
  }

   

  keyPressAlphaNumeric(event) {

    var inp = String.fromCharCode(event.keyCode);

    if (/^[a-zA-Z0-9(),\-:".?@ ]+$/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  ngOnInit() {
    console.log(this.inviteeId,this.eventId);
    
    setTimeout(() => {
      this.store
        .select((state) => state.eventManagement.getEventById)
        // .pipe(skip(1))
        // .pipe(take(1))
        .subscribe((getEventById: any) => {
          console.log('push data wornd',getEventById);
          
          this.formTemplate = []
          console.log(Object.keys(getEventById).length);
          this.EventById = [];
          if (Object.keys(getEventById).length > 0) {
            this.EventById = getEventById;
            if(this.EventById.profilePic != null){
              this.userProfileImage = `${environment.host}/event/getImage/${this.eventId}`;
            }else{
              this.userProfileImage = null
            }
            if((getEventById.eventStatus == 6 && getEventById.is_active == true) || getEventById.is_active == false){
              this.isShowForm = false;    
            }else{
              this.getData = this.EventById.inviteeList.find((res:any)=>res._id === this.inviteeId)
              console.log(this.getData);
              if (this.EventById.eventTemplate.length > 0) {
                this.formTemplate=this.EventById.eventTemplate
                this.showForm(this.formTemplate);
  
              }

            }


      
          }
        });
    }, 100);
  }

  showForm(data) {
    // this.eventRegForm.reset()
    var obj = {};
    data.forEach((element) => {
      // console.log(element);
      // if (element.required) {
      //   obj[element.fieldName] = ["", [Validators.required]];
      // } else 
      if (element.fieldType != 'textview') {
        if (element.required) {
          if(element.fieldName == 'attendee_name'){
            obj[element.fieldName] = [this.getData == undefined?"":this.getData.fullName, [Validators.required,Validators.pattern('^[a-zA-Z ]*$')]];
          }else if(element.fieldName == 'mobileNo'){
            obj[element.fieldName] = [this.getData == undefined?"":this.getData.mobile, [Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]];
          }else if(element.fieldName == 'email'){
            obj[element.fieldName] = [this.getData == undefined?"":this.getData.email, [Validators.required,Validators.email]];
            // Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
          }else{
            obj[element.fieldName] = ['', [Validators.required]];
          }
        
        } else {
          obj[element.fieldName] = [''];
        }
      }
      //  else {
      //   obj[element.fieldName] = [""];
      // }
    });
    this.eventRegForm = this.fb.group(obj);
    this.isShowForm = true;
  }

  submitRegister() {
    if (this.eventRegForm.invalid) {
      return;
    } else {
      var inputObj = {};
      const data = this.eventRegForm.value;
      var inputData:any = [];
      this.EventById.eventTemplate.forEach((element) => {
        inputData = [
          ...inputData,
          {
            fieldId: element._id,
            fieldName: element.fieldName,
            fieldType: element.fieldType,
            fieldValue: data[element.fieldName],
          },
        ];
      });
      inputObj["formData"] = inputData;
      inputObj["eventId"] = this.eventId;
      inputObj["inviteeId"] =this.inviteeId;

      console.log("EVent Registration form value", JSON.stringify(inputObj));

      this.store.dispatch(new SubmitRsvp(inputObj, this.eventId));
      this.store
      .select((state) => state.eventManagement.submitRsbp)
      .subscribe((res: any) => {
        if(Object.keys(res).length > 0){
          const dialog = this.dialog.open(NotificationThanksComponent, {
            width: "450px",
            hasBackdrop: true,
            panelClass: "cmp-modal",
            data: {
              text: "eventFormSubmission",
            },
          });
          dialog.afterClosed().subscribe((response) => {
            console.log(response);
            
            if (response) {

              window.close();
            }
          });

        }
      })



    }
  }

  getsort(arr) {
    return (arr = arr.sort((a, b) => a.sequence - b.sequence));
  }

  getLebel(arr) {
    var findIndex = arr.findIndex((res) => res.fieldType == "textview");
    return arr[findIndex].fieldLabel;
  }

  get getControl() {
    return this.eventRegForm.controls;
  }

   tConvert (time) {
    if(time != undefined){
    // Check correct time format and split into components
    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    console.log(time)
    if (time.length > 1) { // If time format correct
      time = time.slice (1);  // Remove full string match value
      time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join (''); // return adjusted time or original string
    }

  }

  close(){
    window.close()
  }
  
}
